import React from "react";

function MainCard({ children }) {
  return (
    <div className="min-w-screen container bg-lightBlack rounded-l-xl shadow-xl mb-4 mt-8 border-y-2 border-l-2 border-black">
      <div className="px-6 py-3 ">{children}</div>
    </div>
  );
}

export default MainCard;
